import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { AccountManager, SiteConfigManager } from '@atlas/core';
import { DefaultPopup, Label } from '@atlas/ui';

import { useQuickDepositPostHog } from 'hooks/usePostHog';
import { useNotificationsUIContext } from 'src/common/Popup/NotificationsUIContext';
import QuickDepositForm from 'src/common/Popup/QuickDepositPopup/QuickDepositForm';

const QuickDepositPopup = ({ afterDelay, onClose, onCloseClick, setPaymentUrl }) => {
  const { handleCloseClick, handleDepositStart, handleDepositSuccess } = useQuickDepositPostHog({
    afterDelay,
    onCloseClick,
  });
  const { isFlyingBetslip } = useNotificationsUIContext();
  const currency = AccountManager.getAccountCurrency();
  const enableExtendedFlyingBetslip = SiteConfigManager.getConfig(
    'config.config.betslip.enableExtendedFlyingBetslip',
  );
  const subTitle = (
    <Label
      message="quick_deposit_to_activate"
      params={{
        currency,
        minBonusAmount: 3000,
      }}
    />
  );

  return (
    <DefaultPopup
      className={classNames('quick-deposit', {
        'with-flying-betslip': isFlyingBetslip && !enableExtendedFlyingBetslip,
      })}
      headerTitle="quick_deposit_header"
      headerTitlePosition="left"
      onClose={handleCloseClick}
      postHeaderTitle={subTitle}
    >
      <QuickDepositForm
        closeQRCodeOnSuccess
        onClose={onClose}
        onDepositStart={handleDepositStart}
        onDepositSuccess={handleDepositSuccess}
        setPaymentUrl={setPaymentUrl}
      />
    </DefaultPopup>
  );
};

QuickDepositPopup.propTypes = {
  afterDelay: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  setPaymentUrl: PropTypes.func.isRequired,
};

export default QuickDepositPopup;
